import React, { useState, useEffect } from "react";

import UserAccountFormComp from "./UserAccountFormComp";
import UserAccountsDetailComp from "./UserAccountDetailComp";
import { fetchCall } from "../../common/FetchHelpers";
import DateUtil from "../../common/dateUtil";
import { cleanCsvString } from '../../common/Utils';
import { isLevelFourRaymondJames } from "../../common/checkClient";
import ChangeSetDisplayComp from "../common/ChangeSetDisplayComp";

const UserAccountEditComp = (props) => {

    const reqUrl = "api/user-account/update";
    const validationUrl = "api/user-account/validate";

    //const isLevelFourRJ = isLevelFourRaymondJames();

    const [showEditor, setShowEditor] = useState(true);
    const [showError, setShowError] = useState(false);

    const [currentState, setCurrentState] = useState("EDIT");
    const [formStatus, setFormStatus] = useState("");

    const [formData, updateFormData] = useState(props.data);

    const [validation, setValidation] = useState({
        valid: true,
        message: "Form data are valid",
        accountNumber: true,
        accountName: true,
        brokerDealerId: true,
        otherBrokerDealer: true,
        accountRelation: true,
        otherRelation: true,
        accountRegistration: true,
        accountType: true,
        accountOpenDate: true
    });

    const completeValidation = (valid, message) => {
        setValidation({
            ...validation,
            valid, message,
            accountNumber: formData.accountNumber ? true : false,
            accountName: formData.accountName ? true : false,
            brokerDealerId: formData.brokerDealerId ? true : false,
            otherBrokerDealer: (formData.brokerDealerId !== 'Other' || formData.otherBrokerDealer) ? true : false,
            accountRelation: formData.accountRelation ? true : false,
            otherRelation: (formData.accountRelation !== 'Other' || formData.otherRelation) ? true : false,
            accountRegistration: formData.accountRegistration ? true : false,
            accountType: formData.accountType ? true : false,
            accountOpenDate: formData.accountOpenDate ? true : false,
        });

    }

    const validate = () => {
        const valid =
            (formData.accountNumber
            && formData.accountName
            && formData.brokerDealerId
            && (formData.brokerDealerId !== 'Other' || formData.otherBrokerDealer)
            && formData.accountRelation
            && (formData.accountRelation !== 'Other' || formData.otherRelation)
            && formData.accountRegistration
            && formData.accountType
            && formData.accountOpenDate)
            ? true
            : false;
            
        if (valid) {
            const reqOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({ id: formData.id, accountNumber: formData.accountNumber }),
            };

            fetchCall(validationUrl, reqOptions)
                .then((result) => {
                    completeValidation(result.valid, result.message);
                    if (result.valid)
                        setCurrentState("PREVIEW");
                })
                .catch((err) => {
                    completeValidation(false, "Server error, Please contact support");
                });
        } else {
            completeValidation(valid, "Please Enter Required Fields");
        }

        //Client side validation
        // const valid =
        //     formData.accountNumber
        //     && formData.accountName
        //     && formData.brokerDealerId
        //     && (formData.brokerDealerId !== 'Other' || formData.otherBrokerDealer)
        //     && formData.accountRelation
        //     && (formData.accountRelation !== 'Other' || formData.otherRelation)
        //     && formData.accountRegistration
        //     && formData.accountType
        //     && formData.accountOpenDate
        //     ? true
        //     : false;
        // return valid;
    };

    // useEffect(() => {
    //     console.log(validation);

    //   }, [validation]);

    const handleChange = (e) => {
        //console.log(formData);

        if (e.target.name === "brokerDealerId") {
            let rrName = "";

            let rr = props.metadata.brokerDealer.find((obj) => {
                return obj.id === e.target.value;
            });
            if (rr) {
                rrName = rr.name;
            }
            updateFormData({
                ...formData,
                [e.target.name]: e.target.value,
                brokerDealerName: rrName,
            });
        } else {
            updateFormData({
                ...formData,
                [e.target.name]: e.target.value,
            });
        }
    };


    const handleDateChange = (date) => {
        console.log(formData);
        updateFormData({
            ...formData,
            accountOpenDate: date
        });
    };


    const beneficiaryChange = (e, idx) => {
        const temp = [...formData.beneficiaries];
        temp[idx] = e.target.value;
        updateFormData({
            ...formData,
            beneficiaries: temp
        });

    };

    const beneficiaryAdd = () => {
        const beneficiaries = [...formData.beneficiaries, ''];
        updateFormData({
            ...formData,
            beneficiaries: beneficiaries
        });
    }

    const beneficiaryRemove = (idx) => {
        if (formData.beneficiaries.length > 1) {
            const temp = [...formData.beneficiaries];
            temp.splice(idx, 1);
            updateFormData({
                ...formData,
                beneficiaries: temp
            });
        } else {
            updateFormData({
                ...formData,
                beneficiaries: ['']
            });
        }
    }



    const handleSaveClick = () => {
        // users are not allow to change anythign other than beneficiaries, so no need to validate

        if (currentState === "EDIT") {
            validate();
        } else if (currentState === "PREVIEW") {
            handleSubmit();
        }

        // validate();
        // if(validation.valid) {
        //     if (currentState == "PREVIEW") {
        //         handleSubmit();
        //     } else if (currentState == "EDIT") {
        //         setCurrentState("PREVIEW");
        //     }
        // }

    }

    const handleSubmit = () => {

        let jsonData = {
            ...formData,
            brokerDealerId: formData.brokerDealerId === 'Other' ? null : formData.brokerDealerId
            , accountOpenDate: DateUtil.toStrDate(formData.accountOpenDate)
            , accountRelation: formData.accountRelation === 'Other' ? formData.otherRelation : formData.accountRelation
            , beneficiaries: formData.beneficiaries.join('|')
        };

        const reqOptions = {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(jsonData),
        };

        fetchCall(reqUrl, reqOptions)
            .then((result) => {
                console.log(result);
                if (result.status) {
                    setFormStatus("SUCCESS");
                } else {
                    setValidation({ ...validation, valid: result.status, message: result.message })
                    setFormStatus("ERROR");
                }
            })
            .catch((err) => {
                setShowEditor(false);
                setShowError(true);
            });
    };

    return (
        <div className="form">
            <div className="form-header">
                <div className="form-header-label">Edit Account</div>
            </div>

            {(currentState == "EDIT") ?
                <UserAccountFormComp
                    validation={validation}
                    data={formData}
                    metadata={props.metadata}
                    handleChange={handleChange}
                    handleDateChange={handleDateChange}
                    beneficiaryChange={beneficiaryChange}
                    beneficiaryAdd={beneficiaryAdd}
                    beneficiaryRemove={beneficiaryRemove} />
                : <UserAccountsDetailComp data={formData} />
            }

            <div className="form-footer">

                {validation.valid ?
                    ((formStatus === "SUCCESS") ? <div className="form-status success">Account Updated Successfully</div> : <div className="form-status"></div>)
                    : (<div className="form-status error">{validation.message}</div>)}

                <div className="btn-group">
                    <button id="btnGetProductList" type="button" className="btn btn-primary-outline" onClick={props.handleClose}> {formStatus === "SUCCESS" ? "Close" : "Cancel"}</button>
                    {(formStatus !== "SUCCESS") &&
                        <button id="btnLoadProductDetail" type="button" className="btn btn-primary" onClick={handleSaveClick}>{currentState == "EDIT" ? "Save" : "Submit"}</button>
                    }

                </div>
            </div>
            {currentState == "EDIT" && <ChangeSetDisplayComp changeSet={formData.changeSet} />}
        </div >
    );


};

export default UserAccountEditComp;